<div class="cpcontent">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2 class="mb-0">Asset List - Pictures / GLB files ({{ filteredPictureFiles.length }} of {{ pictureFiles.length }} files)</h2>
    <button class="btn btn-outline-info btn-sm" (click)="showInfo = !showInfo" [attr.aria-expanded]="showInfo">
      <i class="bi bi-info-circle me-1"></i>Info
    </button>
  </div>

  <!-- Collapsible Info Section -->
  <div class="alert alert-info mb-3" *ngIf="showInfo">
    <div class="d-flex justify-content-between align-items-start">
      <div>
        <h6 class="alert-heading mb-2">Asset Management Information</h6>
        The assets for the virtual exercise are stored in an S3 buckt in AWS.
        <br>
        Each 3D model asset (GLB file) can has an image file (PNG, JPG, etc.) for preview purposes.
        <br>
        <b>Note:</b> not listed in this table are textures, skyboxes and terrain height maps
      </div>
      <button type="button" class="btn-close" (click)="showInfo = false" aria-label="Close"></button>
    </div>
  </div>

  <!-- Search and Filter Section -->
  <div class="row mb-2 align-items-center">
    <div class="col-md-3">
      <div class="input-group input-group-sm">
        <span class="input-group-text small fw-semibold">Filename</span>
        <span class="input-group-text"><i class="bi bi-search"></i></span>
        <input type="text" class="form-control" id="searchFilename" [(ngModel)]="searchFilename" (input)="onSearchFilenameChange()" placeholder="Enter filename...">
        <button *ngIf="searchFilename" class="btn btn-outline-secondary" type="button" (click)="searchFilename = ''; onSearchFilenameChange()">
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>
    <div class="col-md-3">
      <div class="input-group input-group-sm">
        <span class="input-group-text small fw-semibold" [title]="availableTagsTooltip" style="cursor: help;">Tags</span>
        <span class="input-group-text"><i class="bi bi-tags"></i></span>
        <input type="text" class="form-control" id="searchTags" [(ngModel)]="searchTags" (input)="onSearchTagsChange()" [title]="availableTagsTooltip" placeholder="Enter tag key or value...">
        <button *ngIf="searchTags" class="btn btn-outline-secondary" type="button" (click)="searchTags = ''; onSearchTagsChange()">
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>
    <div class="col-md-6 d-flex align-items-center">
      <button class="btn btn-outline-primary btn-sm me-2" (click)="clearFilters()" [disabled]="!searchFilename && !searchTags">
        <i class="bi bi-arrow-clockwise me-1"></i>Clear All Filters
      </button>
      <small class="text-muted" *ngIf="searchFilename || searchTags">
        Filters active
      </small>
    </div>
  </div>

  <div class="table-responsive" style="max-height: 70vh;">
    <table class="table table-striped table-hover table-sm mb-0">
      <thead class="table-dark sticky-top">
        <tr>
          <th scope="col" class="fw-semibold text-uppercase small sortable" (click)="sortBy('filename')" style="cursor: pointer;">
            File Name <i class="bi ms-1" [class]="getSortIcon('filename')"></i>
          </th>
          <th scope="col" class="fw-semibold text-uppercase small sortable" 
              (click)="sortBy('imagesize')" 
              style="cursor: pointer;">
            Image Size <i class="bi ms-1" [class]="getSortIcon('imagesize')"></i>
          </th>
          <th scope="col" class="fw-semibold text-uppercase small">Tags</th>
          <th scope="col" class="fw-semibold text-uppercase small">GLB File</th>
          <th scope="col" class="fw-semibold text-uppercase small sortable" (click)="sortBy('glbsize')" style="cursor: pointer;">
            GLB Size <i class="bi ms-1" [class]="getSortIcon('glbsize')"></i>
          </th>
          <th scope="col" class="fw-semibold text-uppercase small text-center">Preview</th>
          <th scope="col" class="fw-semibold text-uppercase small text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of filteredPictureFiles; let i = index" class="align-middle">
          <td class="fw-medium">{{ getFileName(file.Key) }}</td>
          <td class="text-muted">{{ getSizeFormatted(file.Size) }}</td>
          <td class="text-muted small">
            <span *ngFor="let tag of file.Tags; let last = last" class="badge bg-info me-1 mb-1" [title]="tag.Key + ': ' + tag.Value">
              {{ tag.Key }}: {{ tag.Value }}<span *ngIf="!last">, </span>
            </span>
            <span *ngIf="file.Tags.length === 0" class="text-muted fst-italic">No tags</span>
          </td>
          <td class="text-muted small">
            <span *ngIf="file.GLBFile" class="badge bg-success" [title]="'GLB file exists: ' + file.GLBFile">
              <i class="bi bi-check-circle me-1"></i>{{ file.GLBFile.split('/').pop() }}
            </span>
            <span *ngIf="!file.GLBFile" class="text-muted fst-italic">
              <i class="bi bi-x-circle me-1"></i>No GLB file
            </span>
          </td>
          <td class="text-muted">
            <span *ngIf="file.GLBSize > 0">{{ getSizeFormatted(file.GLBSize) }}</span>
            <span *ngIf="file.GLBSize === 0" class="text-muted fst-italic">-</span>
          </td>
          <td class="text-center">
            <img *ngIf="file.CanPreview" 
                 [src]="file.DownloadUrl" 
                 [alt]="getFileName(file.Key)" 
                 class="img-thumbnail rounded preview-image" 
                 style="width: 60px; height: 60px; object-fit: cover; cursor: pointer;" 
                 loading="lazy"
                 (click)="openImageModal(file)"
                 title="Click to view full size">
            
            <span *ngIf="!file.CanPreview" class="text-muted small">No preview</span>
          </td>
          <td class="text-center">
            <div class="btn-group btn-group-sm" role="group">
              <a [href]="file.DownloadUrl" target="_blank" class="btn btn-outline-primary" title="View full image">
                <i class="bi bi-eye"></i>
              </a>
              <a [href]="file.DownloadUrl" [download]="getFileName(file.Key)" class="btn btn-outline-secondary" title="Download">
                <i class="bi bi-download"></i>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="filteredPictureFiles.length === 0 && pictureFiles.length > 0" class="text-center py-5">
      <div class="text-muted">
        <i class="bi bi-search display-1 mb-3"></i>
        <h5 class="text-muted">No files match your filters</h5>
        <p class="mb-0">Try adjusting your search criteria or <a href="javascript:void(0)" (click)="clearFilters()">clear all filters</a>.</p>
      </div>
    </div>

    <div *ngIf="pictureFiles.length === 0" class="text-center py-5">
      <div class="text-muted">
        <i class="bi bi-image display-1 mb-3"></i>
        <h5 class="text-muted">No picture files found</h5>
        <p class="mb-0">No picture files found in the S3 bucket.</p>
      </div>
    </div>
  </div>
</div>

<!-- Image Modal -->
<div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true" *ngIf="selectedImage">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="imageModalLabel">{{ getFileName(selectedImage.Key) }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center p-2">
        <img [src]="selectedImage.DownloadUrl" 
             [alt]="getFileName(selectedImage.Key)" 
             class="img-fluid rounded"
             style="max-height: 64vh; max-width: 100%;">
      </div>
      <div class="modal-footer">
        <div class="me-auto">
          <small class="text-muted">
            Size: {{ getSizeFormatted(selectedImage.Size) }} | 
            <span *ngIf="selectedImage.Tags.length > 0">
              Tags: <span *ngFor="let tag of selectedImage.Tags; let last = last">{{ tag.Key }}: {{ tag.Value }}<span *ngIf="!last">, </span></span>
            </span>
            <span *ngIf="selectedImage.Tags.length === 0">No tags</span>
          </small>
        </div>
        <a [href]="selectedImage.DownloadUrl" target="_blank" class="btn btn-outline-primary btn-sm">
          <i class="bi bi-eye me-1"></i>Open Full Size
        </a>
        <a [href]="selectedImage.DownloadUrl" [download]="getFileName(selectedImage.Key)" class="btn btn-outline-secondary btn-sm">
          <i class="bi bi-download me-1"></i>Download
        </a>
        <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>